import axios from "./axios";

export const listAddons = async(id) => {
  try {
    let addons;
    if(id) {
      addons = await axios.get(
        `/api/v1/provision/instance.addon/${id}`
      );
    } else {
      addons = await axios.get(
        `/api/v1/provision/addon`
      );
    }
    return addons;
  } catch(error) {
    return { status: "error", error };
  }
}

export const listVersions = async(id) => {
  try {
    const versions = await axios.get(
      `/api/v1/provision/addon/${id}?op=versions`
    );
    return versions;
  } catch(error) {
    return { status: "error", error };
  } 
}

export const showAddonDetail = async(id, addonId) => {
  try {
    const addons = await axios.get(
      `/api/v1/provision/instance.addon/${id}/${addonId}`
    );
    return addons;
  } catch(error) {
    return { status: "error", error };
  }
}

export const listAvailableAddons = async() => {
  try {
    const addons = await axios.get(
      `/api/v1/provision/addon`
    );
    return addons;
  } catch(error) {
    return { status: "error", error };
  }
}

export const showAvailableAddonDetail = async(id) => {
  try {
    const addon = await axios.get(
      `/api/v1/provision/addon/${id}`
    );
    return addon;
  } catch(error) {
    return { status: "error", error };
  }
}

export const showAddonDetailByVersion = async(id, version) => {
  try {
    const addon = await axios.get(
      `/api/v1/provision/addon/${id}/${version}`
    );
    return addon;
  } catch(error) {
    return { status: "error", error };
  }
}

export const installAddons = async(instanceId, addons) => {
  try {
    const response = await axios.put(
      `/api/v1/provision/instance.addon/${instanceId}`,
      addons
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const updateAddon = async(instanceId, addonId, meta) => {
  try {
    let response;
    if(instanceId) {
      response = await axios.post(
        `/api/v1/provision/instance.addon/${instanceId}/${addonId}?op=update`,
        meta
      );
    } else {
      response = await axios.post(
        `/api/v1/provision/addon/${addonId}?op=update`,
        meta
      );
    }
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const enableAddon = async(instanceId, addonId) => {
  try {
    const response = await axios.post(
      `/api/v1/provision/instance.addon/${instanceId}/${addonId}?op=enable`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const disableAddon = async(instanceId, addonId) => {
  try {
    const response = await axios.post(
      `/api/v1/provision/instance.addon/${instanceId}/${addonId}?op=disable`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const uninstallAddon = async(instanceId, addonId) => {
  try {
    const response = await axios.delete(
      `/api/v1/provision/instance.addon/${instanceId}/${addonId}`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const exportAddon = async(addonId) => {
  try {
    const response = await axios.get(
      `/api/v1/provision/addon/${addonId}?op=export`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const importAddon = async(data) => {
  try {
    const response = await axios.post(`/api/v1/provision/addon?op=import`, data,{
      headers: {
        "Content-Type": "multipart/form-data"
      },
    });
    return response;
  } catch (error) {
    return { status: "error", error };
  }
}

export const createDetailAddon = async(addonId, detail) => {
  try {
    const response = await axios.put(
      `/api/v1/provision/addon/${addonId}`,
      detail
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const updateDetailAddon = async(addonId, version, detail) => {
  try {
    const response = await axios.post(
      `/api/v1/provision/addon/${addonId}/${version}?op=update`,
      detail
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const createAddon = async(detail) => {
  try {
    const response = await axios.put(
      `/api/v1/provision/addon`,
      detail
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const deleteAddonDetail= async(addonId, version) => {
  try {
    const response = await axios.delete(
      `/api/v1/provision/addon/${addonId}/${version}`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const deleteAddon = async(addonId) => {
  try {
    const response = await axios.delete(
      `/api/v1/provision/addon/${addonId}`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const startModule = async(instanceId, module) => {
  try {
    const response = await axios.post(
    `/api/v1/provision/instance/${instanceId}?op=startModule&module=${module}`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const stopModule = async(instanceId, module) => {
  try {
    const response = await axios.post(
    `/api/v1/provision/instance/${instanceId}?op=stopModule&module=${module}`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const purgeModule = async(instanceId, module) => {
  try {
    const response = await axios.post(
    `/api/v1/provision/instance/${instanceId}?op=purgeModule&module=${module}`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}

export const redeployModule = async(instanceId, module) => {
  try {
    const response = await axios.post(
    `/api/v1/provision/instance/${instanceId}?op=redeployModule&module=${module}`
    );
    return response;
  } catch(error) {
    return { status: "error", error };
  }
}